<template>
  <HUIButton
    :spinner="spinner"
    :disabled="disabled"
    :type="type"
    :theme="theme"
    @click="handleClick"
  >
    <slot></slot>
  </HUIButton>
</template>

<script>
import { HUIButton } from '@/halifax-ui'
import routes from '@/router/routes'

export default {
  components: {
    HUIButton
  },
  props: {
    theme: String,
    type: String,
    disabled: Boolean,
    spinner: Boolean,
    to: {
      type: [String, Object],
      required: true,
      validator: value => {
        value = typeof value === 'string' ? value : value.name
        return typeof routes[value] !== 'undefined' || value === 'BACK'
      }
    },
    query: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  created() {},
  methods: {
    handleClick(event) {
      if (this.to === 'BACK' || this.to.name === 'BACK') {
        this.$router.go(-1)
      } else {
        if (typeof this.to === 'string') {
          this.$router.push({ name: this.to })
        } else {
          this.$router.push(this.to)
        }
      }

      this.$emit('click', event)
    }
  }
}
</script>

<style lang="scss">
</style>
